import { mapActions, mapGetters } from "vuex";

export default {
  name: "nav-bar",
  computed: {
    ...mapGetters({
      user: "profile/user",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      isManager: "profile/isManager",
      webinarList: "cosmobase/webinarList"
    }),
  },
  async created() {
    await Promise.all([
      this.getWebinars()
    ])
  },
  methods: {
    ...mapActions({
      getWebinars: "cosmobase/GET_WEBINARS",
      logout: "auth/LOGOUT",
    }),
  },
};
